module.exports = __webpack_public_path__ + "assets/transportation_blue.6b76538d.svg";